import { Trans } from "react-i18next";import { X } from "lucide-react";
import { cn } from "../../../lib/utils";
import {
  Dialog,
  DialogOverlay,
  DialogPortal,
  DialogTitle } from
"../../../components/ui/dialog";
import * as DialogPrimitive from "@radix-ui/react-dialog";

/*
import { useState, useEffect, useMemo } from "react";
import { CalendarIcon, X } from "lucide-react";
import { format } from "date-fns";
import { cn } from "../../../lib/utils";
import {
  Dialog,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
} from "../../../components/ui/dialog";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { Textarea } from "../../../components/ui/textarea";
import { getLeaveApiErrorMessage } from "../../../lib/leaveApiMessages";
import { LeaveStatusBadge } from "./LeaveStatusBadge";

function generateLeavesDetail(
  startStr,
  endStr,
  fromSession = "First Half",
  toSession = "Second Half"
) {
  try {
    const parseDate = (s) => {
      const parts = s.split("-");
      if (parts.length === 3) {
        if (parts[0].length === 4) {
          return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
        }
        return new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));
      }
      return new Date(s);
    };

    const start = parseDate(startStr);
    const end = parseDate(endStr);
    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
      return [];
    }

    const details = [];
    let current = new Date(start);

    while (current <= end) {
      const dateKey = format(current, "yyyy-MM-dd");
      const isStart = format(current, "yyyy-MM-dd") === format(start, "yyyy-MM-dd");
      const isEnd = format(current, "yyyy-MM-dd") === format(end, "yyyy-MM-dd");

      let firstHalf = "Y";
      let secondHalf = "Y";

      if (isStart && fromSession === "Second Half") {
        firstHalf = "N";
      }
      if (isEnd && toSession === "First Half") {
        secondHalf = "N";
      }

      details.push({
        date: dateKey,
        firstHalf,
        secondHalf,
      });

      current.setDate(current.getDate() + 1);
    }

    return details;
  } catch (e) {
    console.error("Error generating leaves detail:", e);
    return [];
  }
}
*/

export function RevokeLeaveModal({
  open,
  onOpenChange,
  leaveRequest
  // onConfirm — preserved for when revoke is re-enabled (see commented implementation below)
}) {
  if (!leaveRequest) return null;

  /*
  const [checkedSessions, setCheckedSessions] = useState({});
  const [revocationReason, setRevocationReason] = useState("");
  const [revocationError, setRevocationError] = useState("");
  const [selectionError, setSelectionError] = useState("");
  const [loading, setLoading] = useState(false);
   useEffect(() => {
    if (open && leaveRequest) {
      const details = (leaveRequest.leavesDetail && leaveRequest.leavesDetail.length > 0)
        ? leaveRequest.leavesDetail
        : generateLeavesDetail(
            leaveRequest.from,
            leaveRequest.to,
            leaveRequest.fromSession,
            leaveRequest.toSession
          );
      const initial = {};
      details.forEach((d) => {
        initial[d.date] = {
          firstHalf: d.firstHalf === "Y",
          secondHalf: d.secondHalf === "Y",
        };
      });
      setCheckedSessions(initial);
      setRevocationReason("");
      setRevocationError("");
      setSelectionError("");
    }
  }, [open, leaveRequest]);
   const parseDateStr = (s) => {
    const parts = s.split("-");
    if (parts.length === 3) {
      return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
    }
    return new Date(s);
  };
   const hasCheckedSession = useMemo(() => {
    return Object.values(checkedSessions).some(
      (s) => s.firstHalf || s.secondHalf
    );
  }, [checkedSessions]);
   const totalLeaveDays = useMemo(() => {
    return Object.values(checkedSessions).reduce((sum, s) => {
      let days = 0;
      if (s.firstHalf) days += 0.5;
      if (s.secondHalf) days += 0.5;
      return sum + days;
    }, 0);
  }, [checkedSessions]);
   const derivedLeavesDetail = useMemo(() => {
    if (!leaveRequest) return [];
    if (leaveRequest.leavesDetail && leaveRequest.leavesDetail.length > 0) {
      return leaveRequest.leavesDetail;
    }
    return generateLeavesDetail(
      leaveRequest.from,
      leaveRequest.to,
      leaveRequest.fromSession,
      leaveRequest.toSession
    );
  }, [leaveRequest]);
   const handleConfirmRevoke = async () => {
    if (!hasCheckedSession) {
      setSelectionError("Please select at least one session to revoke.");
      return;
    }
     if (!revocationReason.trim()) {
      setRevocationError("Reason for revoking leave is required.");
      return;
    }
     setSelectionError("");
    setRevocationError("");
    setLoading(true);
    try {
      await onConfirm(revocationReason, checkedSessions);
      onOpenChange(false);
    } catch (err) {
      console.error("Revocation failed:", err);
      setRevocationError(getLeaveApiErrorMessage(err) || "Request failed.");
    } finally {
      setLoading(false);
    }
  };
   const toggleSession = (dateStr, sessionKey) => {
    setCheckedSessions((prev) => {
      const next = {
        ...prev,
        [dateStr]: {
          ...prev[dateStr],
          [sessionKey]: !prev[dateStr][sessionKey],
        },
      };
      if (Object.values(next).some((s) => s.firstHalf || s.secondHalf)) {
        setSelectionError("");
      }
      return next;
    });
  };
  */










  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogPortal>
        <DialogOverlay className="bg-[#0a1230]/50 backdrop-blur-sm" />
        <DialogPrimitive.Content
          className={cn(
            "fixed left-[50%] top-[50%] z-50 translate-x-[-50%] translate-y-[-50%]",
            "w-[95vw] sm:w-[90vw] md:w-[480px] max-w-[480px]",
            "max-h-[90vh] overflow-hidden flex flex-col",
            "bg-white rounded-2xl shadow-[0_30px_80px_-20px_rgba(30,51,131,0.45)] border border-white/60",
            "duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
            "font-sans"
          )}>
          
          <div className="flex items-center justify-between px-6 py-3.5 border-b border-[var(--color-text-border)]/70 shrink-0">
            <DialogTitle className="text-[20px] font-semibold text-foreground tracking-tight">
              <Trans i18nKey="formActions.revokeLeaveRequest" />
            </DialogTitle>
            <DialogPrimitive.Close className="h-9 w-9 grid place-items-center rounded-xl text-[var(--color-text-secondary)] hover:bg-[var(--color-workspace)]/60 hover:text-[var(--color-primary)] transition">
              <X className="h-5 w-5" />
              <span className="sr-only"><Trans i18nKey="formActions.close" /></span>
            </DialogPrimitive.Close>
          </div>

          <div className="px-6 py-10 overflow-y-auto flex-1 text-center">
            <p className="text-base font-semibold text-foreground"><Trans i18nKey="leave.featureComingSoon" /></p>
            <p className="mt-2 text-sm text-[var(--color-text-secondary)] leading-relaxed">
              <Trans i18nKey="leave.leaveRevocationWillBeAvailableInAFuture" />
            </p>
          </div>

          <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-3 px-6 py-4 border-t border-[var(--color-text-border)]/70 shrink-0">
            <DialogPrimitive.Close className="h-11 px-5 rounded-xl bg-[var(--color-primary)] text-white text-sm font-semibold hover:opacity-90 transition cursor-pointer">
              <Trans i18nKey="formActions.close" />
            </DialogPrimitive.Close>
          </div>

          {/*
            Original revoke modal body and footer (preserved for re-enable):
            <div className="px-6 py-5 space-y-5 overflow-y-auto flex-1">
             ... structured details card, session breakdown table, reason textarea ...
            </div>
            <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-3 px-6 py-4 border-t border-[var(--color-text-border)]/70 shrink-0">
             <button
               onClick={handleConfirmRevoke}
               disabled={loading}
               className="h-11 px-5 rounded-xl bg-[var(--color-warning)] text-white text-sm font-semibold hover:opacity-90 transition shadow-[0_8px_20px_-8px_rgba(245,158,11,0.5)] cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
             >
               {loading ? "Revoking..." : "Confirm Revoke"}
             </button>
            </div>
            */

          }
        </DialogPrimitive.Content>
      </DialogPortal>
    </Dialog>);

}
